import Vue from 'vue'
import moment from 'moment'
import { removeToken } from '@/utils/auth'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

const mutations = {
    updateCurrentLocation(state, latLng) {
        state.currentLocation = latLng
    },
    setResults(state, items) {
        Vue.set(state, 'results', items)
    },
    addToResults(state, item) {
        const placeholderID = state.results.findIndex((i) => i.showPlaceholder)
        if (placeholderID >= 0) {
            Vue.set(state.results, placeholderID, item)
        } else {
            state.results.push(item)
        }
    },
    logoutUser(state) {
        state.auth.token = ''
        removeToken()
        Vue.set(state, 'defaultSuccess', 'Successfully logged out')
    },
    clearResults(state) {
        Vue.set(state, 'results', [])
    },
    setLoading(state, loading) {
        state.isLoading = loading
    },
    setCurrentJourney(state, journey) {
        Vue.set(state, 'currentJourney', journey)
    },
    clearSearchQuery(state) {
        state.searchQuery = null
    },
    setSearchQuery(state, searchQuery) {
        const data = searchQuery
        /* we don't need journeys - they are stored under results */
        delete data.journeys
        Vue.set(state, 'searchQuery', data)
        state.origin = data.origin_address
        state.destination = data.destination_address
    },
    setError(state, { field, error }) {
        Vue.set(state.errors, field, error)
    },
    clearErrors(state) {
        Vue.set(state, 'errors', {})
    },
    setDefaultError(state, error) {
        Vue.set(state, 'defaultError', error)
    },
    setDefaultSuccess(state, success) {
        Vue.set(state, 'defaultSuccess', success)
        setTimeout(() => {
            this.commit('setDefaultSuccess', false)
        }, 10000);
    },
    removeDefaultSuccess(state) {
        Vue.set(state, 'defaultSuccess', false)
    },
    setSearchQueryResults(state, results) {
        state.searchQuery.results_retrieved = results
    },
    initFormValues(state) {
        if (state.searchQuery) {
            state.form.origin = state.searchQuery.origin_address
            state.form.destination = state.searchQuery.destination_address
            state.form.out_time = moment(state.searchQuery.out_departure_at, 'DD/MM/YYYY HH:mm').toISOString()
            state.form.return_time = state.searchQuery.return_departure_at ? moment(state.searchQuery.return_departure_at, 'DD/MM/YYYY HH:mm').toISOString() : null
        }
    },
    updateOrigin(state, origin) {
        state.origin = origin
    },
    setUserToken(state, token) {
        state.auth.token = token
    },
    setUserInfo(state, user) {
        Vue.set(state, 'user', user)
    },
    userSavedJourneys(state, response) {
        Vue.set(state.user, 'savedJourneys', response)
    },
    userRecentJourneys(state, response) {
        Vue.set(state.user, 'recentJourneys', response)
    },
    recentJourneysMeta(state, response) {
        Vue.set(state.user, 'recentJourneysMeta', response)
    },
    savedJourneysMeta(state, response) {
        Vue.set(state.user, 'savedJourneysMeta', response)
    },
    markCurrentJourneySaved(state) {
        Vue.set(state.currentJourney, 'user_status', 'saved')
    },
    activeCampaign(state, response) {
        state.activeCampaign = response
    },
    addCampaignImpression(state, impression) {
        state.campaignImpressions.push(impression)
        state.activeCampaignImpression = impression
    },
    resetActiveCamapignAndImpression(state) {
        state.activeCampaign = null
        state.activeCampaignImpression = null
    },
    addResultQueryStages(state, stages) {
        state.resultQueryStages = stages
        if (whitelabel.enableMultipleJourneyTypeFilter) {
            state.selectedMultipleResultStages = stages
        }
    },
    setMultipleResultStages(state, stages) {
        state.selectedMultipleResultStages = stages
    },
    setResultSort(state, sort) {
        state.resultSort.selected = sort
    },
    handleMultipleFilterChange(state, { stage, e }) {
        state.selectedMultipleResultStages = e.target.checked
            ? [...new Set([...state.selectedMultipleResultStages, stage])]
            : state.selectedMultipleResultStages.filter((s) => s !== stage);
    },

}

export default mutations
